import {
  Image,
  Modal,
  ModalContent,
  useIsMobile,
  Icon
} from '@epilot/concorde-elements'
import { getOptimizedImageURL } from '@epilot/journey-logic-commons'
import classNames from 'classnames'
import { useState } from 'react'

import { useAppStoreSelector } from '../../../../hooks/useAppStoreSelector'
import { selectDarkMode } from '../../../../store/selectors/runtime'

import classes from './ChoiceImage.module.scss'

const OPTIMAL_IMAGE_WIDTH = 400
const OPTIMAL_IMAGE_WIDTH_MODAL = 1200
const OPTIMAL_ICON_WIDTH = 120
const DEFAULT_IMAGE_URL =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/681px-Placeholder_view_vector.svg.png'

type ChoiceImageButtonProps = {
  url: string
  imageId: string
  imageType?: 'infographic' | 'icon'
  IMAGE_PREVIEW_API_URL: string
  alt?: string
  isAnimated?: boolean
}

export const ChoiceImage = (props: ChoiceImageButtonProps) => {
  const { imageType, IMAGE_PREVIEW_API_URL, url, imageId, alt, isAnimated } =
    props
  const [isModalOpen, setIsModalOpen] = useState(false)
  const isMobile = useIsMobile()
  const darkMode = useAppStoreSelector(selectDarkMode)

  const isInfographic = imageType === 'infographic' || imageType === undefined

  const optimizedImageURL = url
    ? getOptimizedImageURL({
        apiUrl: IMAGE_PREVIEW_API_URL,
        imageURL: url,
        fileId: imageId,
        width: isInfographic ? OPTIMAL_IMAGE_WIDTH : OPTIMAL_ICON_WIDTH
      })
    : DEFAULT_IMAGE_URL

  const optimizedImageURLModal = url
    ? getOptimizedImageURL({
        apiUrl: IMAGE_PREVIEW_API_URL,
        imageURL: url,
        fileId: imageId,
        width: OPTIMAL_IMAGE_WIDTH_MODAL
      })
    : DEFAULT_IMAGE_URL

  const imageProps = {
    className: classes.image,
    'data-testid': 'image-control',
    fallbackSrc: url,
    src: optimizedImageURL,
    alt: alt || 'label',
    isAnimated: isAnimated
  }

  return (
    <div
      className={
        imageType !== 'infographic'
          ? classes.iconContainer
          : classes.infographicContainer
      }
    >
      <Image
        {...imageProps}
        aria-hidden="true"
        className={classNames(
          classes.image,
          imageType !== 'infographic'
            ? classes.iconImage
            : classes.infographicImage
        )}
        tabIndex={-1}
      />
      {!isMobile && (
        <Icon
          aria-hidden="true"
          className={classNames(classes.expandButton, darkMode && classes.dark)}
          name="expand_content"
          onClick={(event) => {
            event.stopPropagation()
            setIsModalOpen(true)
          }}
        />
      )}
      <Modal
        closeButtonClassname={classes.closeButton}
        closeButtonProps={{
          buttonVariant: 'primary'
        }}
        onClose={() => setIsModalOpen(false)}
        open={isModalOpen}
        showCloseButton
      >
        <ModalContent>
          <Image
            {...imageProps}
            className={classes.imageModal}
            src={optimizedImageURLModal}
          />
        </ModalContent>
      </Modal>
    </div>
  )
}
